import axios from 'axios'
import { errorHandler } from "../exports/error_management"
import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-customer-agent-key'
const api = async (method, path, params) => axios[method](path, params)

const state = {
    customer_agent: {},
    pagination: null,
    customer_agents: [],
    deleting: false
}

const mutations = {
    set_customer_agent(state, payload) {
        state.customer_agent = payload
    },
    set_customer_agents(state, payload) {
        state.customer_agents = payload
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    async create(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            const results = await api('post', `customer-agent`, payload)
            context.commit('set_customer_agent', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            const results = await api('get', `customer-agent/${id}`)
            context.commit('set_customer_agent', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `customer-agent`)
                const data = results.data.success.data.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_customer_agents', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetch(context, params) {
        let { query, page: pg } = params || {}
        query = query || ''
        pg = pg || 1

        const path = `customer-agent?q=${query}&page=${pg}`
        console.log('--path--', path)
        const result = await axios.get(path)
        // return api
        //     .fetch(query, pg)
        //     .then(result => {
        let {
            data,
            current_page: page,
            per_page: pageSize,
            total,
        } = result.data.success.data
        context.commit('set_customer_agents', data)
        context.commit('set_pagination', {
            page,
            pageSize,
            total,
        })
    },


    async update(context, payload) {
        console.log('update', payload)
        new StorageCache(storageKey).reset()
        try {
            const results = await api(
                'put',
                `customer-agent/${payload.id}`,
                payload
            )
            context.commit('set_customer_agent', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        new StorageCache(storageKey).reset()
        try {
            await api('delete', `customer-agent/${id}`)
            context.commit('set_customer_agents', null)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}